(function () {
  'use strict';

  angular.module('core.factories', [
    'factories.formExceptionHandler',
    'factories.httpInterceptor',
    'factories.punycode',
  ]);
})();
